// extracted by mini-css-extract-plugin
module.exports = {"wrap":"NotFound_wrap__1th9o"};